import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ContactFormComponent } from "./contact-form.component";
import { BigMailChimpFormModule } from '../big-mailchimp-form/big-mailchimp-form.module'
import { ImageAnimationModule } from "../image-animation/image-animation.module";
@NgModule({
  declarations: [
    ContactFormComponent,
  ],
  imports: [BigMailChimpFormModule, CommonModule, ImageAnimationModule],
  exports:[CommonModule, ContactFormComponent],
  providers: [],
  bootstrap: [],
})
export class ContactFormModule {}
